import _regeneratorRuntime from "@babel/runtime/regenerator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/*global seatsio*/
import React from 'react';
import { didPropsChange } from './util';

var Embeddable =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Embeddable, _React$Component);

  function Embeddable(props) {
    var _this;

    _classCallCheck(this, Embeddable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Embeddable).call(this, props));
    _this.container = React.createRef();
    return _this;
  }

  _createClass(Embeddable, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.createAndRenderChart();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(prevProps) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (didPropsChange(this.props, prevProps) && this.chart) {
                  this.destroyChart();
                  this.createAndRenderChart();
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "createAndRenderChart",
    value: function () {
      var _createAndRenderChart = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var seatsio, config;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getSeatsio();

              case 2:
                seatsio = _context3.sent;
                config = this.extractConfigFromProps();
                config.container = this.container.current;
                this.chart = this.createChart(seatsio, config).render();

                if (this.props.onRenderStarted) {
                  this.props.onRenderStarted(this.chart);
                }

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function createAndRenderChart() {
        return _createAndRenderChart.apply(this, arguments);
      }

      return createAndRenderChart;
    }()
  }, {
    key: "extractConfigFromProps",
    value: function extractConfigFromProps() {
      // noinspection JSUnusedLocalSymbols
      var _this$props = this.props,
          divId = _this$props.divId,
          container = _this$props.container,
          onRenderStarted = _this$props.onRenderStarted,
          chartJsUrl = _this$props.chartJsUrl,
          region = _this$props.region,
          config = _objectWithoutProperties(_this$props, ["divId", "container", "onRenderStarted", "chartJsUrl", "region"]);

      return config;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyChart();
    }
  }, {
    key: "destroyChart",
    value: function destroyChart() {
      if (this.chart && this.chart.state !== 'DESTROYED') {
        this.chart.destroy();
      }
    }
  }, {
    key: "getSeatsio",
    value: function getSeatsio() {
      if (typeof seatsio === 'undefined') {
        return this.loadSeatsio();
      } else if (seatsio.region !== this.props.region) {
        seatsio = undefined;
        return this.loadSeatsio();
      } else {
        return Promise.resolve(seatsio);
      }
    }
  }, {
    key: "loadSeatsio",
    value: function loadSeatsio() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var script = document.createElement('script');

        script.onload = function () {
          seatsio.region = _this2.props.region;
          resolve(seatsio);
        };

        script.onerror = function () {
          return reject("Could not load ".concat(script.src));
        };

        script.src = _this2.props.chartJsUrl.replace('{region}', _this2.props.region);
        document.head.appendChild(script);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        ref: this.container,
        style: {
          'height': '100%'
        }
      });
    }
  }]);

  return Embeddable;
}(React.Component);

export { Embeddable as default };
Embeddable.defaultProps = {
  chartJsUrl: 'https://cdn-{region}.seatsio.net/chart.js'
};